import { useState } from 'react';
/* document */
import { FinderPublic } from '../Document/FinderPublic.js';
import { FilterBkgColor } from '../Filters/FilterBkgColor.js';
import { BlockMenuPublic } from '../Blocks/BlockMenuPublic.js';

export const Navigation = (props) => {
    const parks = props.navParks ? props.navParks : [];
    const bkgColor = FilterBkgColor();
    const [show, setShow] = useState(0);
    const [showSub, setShowSub] = useState(0);
    return (
        <div className={`navigation ${bkgColor}`}>
            <div className="buttons">
                <div className="slider" onClick={() => { show === 1 ? setShow(0) : setShow(1); setShowSub(0); }}><i className="fa fa-bars"></i></div>
                <div className={`nav ${show === 1 ? 'show' : 'hide'}`}>
                    {parks.map((park, i) => {
                        return (
                            <BlockMenuPublic label={`park-${park.pid}`} showSub={showSub} setShowSub={setShowSub} park={park} key={i} />
                        )
                    })}
                    <BlockMenuPublic label="history" showSub={showSub} setShowSub={setShowSub} />
                    <BlockMenuPublic label="character" showSub={showSub} setShowSub={setShowSub} />
                    <BlockMenuPublic label="classement" showSub={showSub} setShowSub={setShowSub} />
                </div>
                <a className="logo-nav" href="/" alt="Home">
                    <i className="fa fa-home"></i>
                    <div>Home</div>
                </a>
            </div>
            <div className="buttons">
                <FinderPublic />
            </div>
        </div>
    )
}